///<reference path='../typings/index.d.ts' />
///<reference path='config.ts' />
///<reference path='manifest/assets.ts' />
///<reference path='controller/audiocontroller.ts' />
///<reference path='layer/receiverplaybutton.ts' />
///<reference path='layer/senderplaybutton.ts' />
///<reference path='layer/endreplaybutton.ts' />
///<reference path='scenemanager.ts' />


module agi.expressions.card {
    import EventBus           = agi.expressions.event.EventBus;
    import Event              = agi.expressions.event.Event;
    import Config             = agi.expressions.card.Config;
    import AssetsManifest     = agi.expressions.card.manifest.AssetManifest;
    import PlayButton         = agi.expressions.card.layer.PlayButton;
    import SenderPlayButton   = agi.expressions.card.layer.SenderPlayButton;
    import ReceiverPlayButton = agi.expressions.card.layer.ReceiverPlayButton;
    import EndReplayButton    = agi.expressions.card.layer.EndReplayButton;
    import SceneManager       = agi.expressions.card.SceneManager;
    import AudioController    = agi.expressions.card.controller.AudioController;

    export enum Mode {Sender, Preview, Receiver};

    export type CardData = {
        background:string;
        sendCallback(event:Event, personalizations?:any):Function;
        setPersonalizationsCallback(event:Event, personalizations:any):Function;
        personalizations:any;
    }

    export type CardOptions = {
        sheetUrls:string[];
        playButtonUrl:string;
        endScreenUrl:string;
        desktopMenuUrls:string[];
        container:HTMLElement;
        sendCallback(event:Event, personalizations?:any):Function;
        setPersonalizationsCallback(event:Event, personalizations:any):Function;
        cardData:CardData;
        assetPath:string;
        assetManifest:AssetsManifest;
        personalizations:any;
    }

    export class CardBase {
        // signals
        public allLoaded:Signal = new signals.Signal();

        protected domParent:HTMLElement = document.body; //TODO need to pass this in
        protected input:HTMLInputElement;
        protected mode:Mode;
        protected assetManifest:AssetsManifest;
        protected renderer:PIXI.WebGLRenderer|PIXI.CanvasRenderer;
        protected desktopButtons:Array<HTMLDivElement> = [];
        protected desktopView:boolean = false;
        protected desktopMeasureContainer;
        protected desktopFramePosTop:number = 0;
        protected desktopFramePosLeft:number = 0;
        protected desktopFramePaddingTop:number = 0;
        protected desktopFramePaddingLeft:number = 0;
        protected desktopZIndex:number = 0;

        // load statuses
        protected isSoundFxLoaded:boolean = false;
        protected isPixiAssetsLoaded:boolean = false;
        protected cardPlaying:boolean = false;

        // display objects
        protected stage:PIXI.Container;
        protected touchSupressionHandler:(event:any)=>void;
        protected resizeHandler:(event:any)=>void;
        protected isFullScreen:boolean = false;
        protected renderedDesktop:boolean = false;

        protected sheetUrls:string[];
        protected container:HTMLElement;
        protected playButton:PlayButton;
        protected endButton:PlayButton;
        protected cardData:CardData;
        protected shouldAnimate:boolean = false;
        protected sceneManager:SceneManager;

        protected audioController:AudioController;

        //Event Bus
        protected eventBus:EventBus = EventBus.getInstance();

        constructor(options:CardOptions){
            //Override asset path if passed in
            if (options.assetPath !== undefined){
                Config.ASSET_PATH = options.assetPath;
            }

            //Setting pers if they are there
            if (options.personalizations !== undefined){
                options.cardData.personalizations = options.personalizations;
            }
            else {
                options.cardData.personalizations = Config.DEFAULT_PERS;
            }

            //Setting Asset Manifest
            if (options.assetManifest !== undefined){
                this.assetManifest = options.assetManifest;
            }
            else{
                this.assetManifest = new AssetsManifest(Config.ASSET_PATH);
            }

            this.sheetUrls = this.assetManifest.sheetUrls;
            this.cardData = options.cardData;
            this.domParent = options.container;
        }

        public setGlobalScale(value:number):void {
            Config.SCALE_FACTOR = value;
        }

        public load():void{
            // load pixi
            PIXI.loader.add(this.sheetUrls).load( ()=>{
               this.isPixiAssetsLoaded = true;
               this.checkLoadStatuses();
            });

            this.audioController = new AudioController(this.assetManifest);
            this.audioController.load(this.checkLoadStatuses.bind(this));

            this.eventBus.addEventListener("playButtonClicked", this.onPlayClick.bind(this));
            this.eventBus.addEventListener("shouldAnimate", this.handleShouldAnimate.bind(this));
            this.eventBus.addEventListener("closeButton", this.handleCloseButton.bind(this));
            this.eventBus.addEventListener("send", this.handleSendButton.bind(this));
            this.eventBus.addEventListener("replay", this.resetShow.bind(this));
            this.eventBus.addEventListener("reset", this.resetShow.bind(this));
            this.eventBus.addEventListener("setPers", this.handleSetPersonalizations.bind(this));
        }

        public animate(timeDelta?:number) {
            if (this.shouldAnimate){
                this.sceneManager.animate(timeDelta);
                this.renderer.render(this.stage);
            }
        }

        public setRenderDesktop(value:boolean, top:number, left:number,
            zIndex:number, paddingTop:number, paddingLeft:number,
            measureContainer:HTMLDivElement):void
        {
            this.desktopView = value;
            this.desktopFramePosTop = top;
            this.desktopFramePosLeft = left;
            this.desktopZIndex = zIndex;
            this.desktopFramePaddingTop = paddingTop;
            this.desktopFramePaddingLeft = paddingLeft;
            this.desktopMeasureContainer = measureContainer;
            Config.IS_DESKTOP_VIEW = true;
        }

        protected checkLoadStatuses():void{
            var isAllLoaded:boolean = this.isPixiAssetsLoaded && this.audioController.sfxLoaded;
            isAllLoaded && this.allLoaded.dispatch();
        }

        protected onPlayClick(event:any):void{
            if (!this.cardPlaying){
                this.cardPlaying=true;
            }
            else {
                this.shouldAnimate = true;
            }

            this.audioController.playTracks();
        }

        public setup(mode:Mode){
            this.mode = mode;
            this.renderer = PIXI.autoDetectRenderer(
                Config.BASE_WIDTH, 
                Config.BASE_HEIGHT, 
                {backgroundColor : 0x171d3c}
            );

            var cardDiv:HTMLDivElement = document.createElement('div');
            cardDiv.id = "pixi-card";
            cardDiv.style.position = "absolute";
            cardDiv.appendChild(this.renderer.view);

            // stage container
            this.stage = new PIXI.Container();
            this.stage.interactive = true;

            this.sceneManager = new SceneManager(
                cardDiv,
                this.stage,
                this.domParent.parentElement,
                this.cardData.personalizations,
                this.assetManifest,
                this.mode
            );
            this.sceneManager.init(this.renderer);

            this.createPlayButton(cardDiv);
            this.domParent.appendChild(cardDiv);

            //Start rendering in 550x550
            this.renderInSquare();
            this.resizeHandler = (event)=>{this.resize(event);};
            window.addEventListener("resize", this.resizeHandler);
        }

        public createPlayButton(container:HTMLDivElement):void {
            // dom play button (mainly to kick off audio on iOS)
            if (this.mode === Mode.Sender){
                this.playButton = new SenderPlayButton(container, 
                    this.domParent.parentElement, this.assetManifest);
            }
            else {
                this.playButton = new ReceiverPlayButton(container,
                    this.domParent.parentElement, this.assetManifest);
            }

            this.endButton = new EndReplayButton(container,
                this.domParent.parentElement, this.assetManifest);
            this.endButton.init();
            this.endButton.hide();

            this.playButton.init();

            this.renderer.view.style.touchAction = "none";
            this.renderer.view.style.msTouchAction = "none";
        }

        protected resetShow():void{
            this.audioController.restart();
        }

        //Different ways to render the card
        // SQUARE: Initial rendering mode with a play or a replay button. The canvas
        //         is hit behind it
        //
        // FULLSCREEN: Fullscreen is Scale to FIT. Canvas will be scaled to fit with the
        //             container set to a black background for a letterbox.
        //
        // DESKTOP FRAME: Desktop view is only for Desktop and has a custom frame for the product.

        public renderInSquare():void {
            //Fit in 550x550
            Config.IS_SQUARE = true;
            this.isFullScreen = false;

            //Reset renderer if it was in portrait
            if (Config.IS_PORTRAIT){
                this.stage.rotation = 0;
                this.stage.x = 0;
                this.stage.y = 0;
                this.renderer.resize(Config.BASE_WIDTH, Config.BASE_HEIGHT);
                Config.IS_PORTRAIT = false;
            }

            var container:HTMLElement = this.renderer.view.parentElement;
            container.style.position = "absolute";
            container.style.left = "0px";
            container.style.top = "0px";
            container.style.backgroundColor = "transparent";
            container.style.margin = "0 auto";
            var canvas = this.renderer.view;
            var innerHeightAdjustment = .95; //Add some padding for landscape
            var combinedPadding = 40;
            var width = Config.SQUARE_SIZE;
            if (container.parentElement){
                width = container.parentElement.offsetWidth;
            }

            if (window.innerHeight < width) {
                width = window.innerHeight * innerHeightAdjustment;
            }

            container.style.width = width + "px";
            container.style.height = width + "px";
            container.style.maxWidth = width + "px";
            container.style.transformOrigin = "0px 0px";
            container.style.webkitTransformOrigin = "0px 0px";
            container.style.transform = "scale(1,1)";
            container.style.webkitTransform = "scale(1,1)";
            container.style.zIndex = "0";
            var sx = width/canvas.width;
            var marginTop = (width - (canvas.height * sx)) / 2;
            var scale = "scale("+sx+","+sx+")";
            canvas.style.transformOrigin = "0px 0px";
            canvas.style.webkitTransformOrigin = "0px 0px";
            canvas.style.transform = scale;
            canvas.style.webkitTransform = scale;
            canvas.style.marginTop = marginTop + "px";
            canvas.style.marginLeft = "0px";
            canvas.style.position = "relative";
            canvas.style.top = "0px";
            canvas.style.left = "0px";
            if (this.touchSupressionHandler !== undefined){
                container.removeEventListener("touchstart", this.touchSupressionHandler);
                container.removeEventListener("touchmove", this.touchSupressionHandler);
                this.touchSupressionHandler = undefined;
            }

            document.body.style.overflowY = "visible";
            document.body.style.overflowX = "hidden";
            if (this.desktopButtons.length > 0){
                for (var i=0; i<this.desktopButtons.length; i++){
                    this.desktopButtons[i].style.display = "none";
                }
            }
        }

        public renderFullscreen():void {
            //Fit to the current Window
            var windowWidth:number = window.innerWidth;
            var windowHeight:number = window.innerHeight;
            var canvas:HTMLCanvasElement = this.renderer.view;
            var container:HTMLElement = this.renderer.view.parentElement;
            var scale:string;

            if (windowHeight > windowWidth){
                Config.IS_PORTRAIT = true;
            }
            else {
                Config.IS_PORTRAIT = false;
            }

            //Portrait
            if (Config.IS_PORTRAIT){
                //Only resize portrait once
                if (this.stage.rotation !== Math.PI/2){
                    this.stage.rotation = Math.PI/2;
                    this.stage.x = Config.BASE_HEIGHT;
                    this.stage.y = 0;
                    this.renderer.resize(Config.BASE_HEIGHT, Config.BASE_WIDTH);
                }
            }
            //Landscape
            else {
                //Reset if the stage was rotated before
                if (this.stage.rotation !== 0){
                    this.stage.rotation = 0;
                    this.stage.x = 0;
                    this.stage.y = 0;
                    this.renderer.resize(Config.BASE_WIDTH, Config.BASE_HEIGHT);
                }
            }

            var sx:number = windowWidth / this.renderer.width;
            var sy:number = windowHeight / this.renderer.height;
            if (sx <= sy){
                scale = "scale("+sx+","+sx+")";
                canvas.style.marginLeft = "0px";
                canvas.style.marginTop = (windowHeight - (this.renderer.height * sx)) * .5 + "px"
            }
            else{
                scale = "scale("+sy+","+sy+")";
                canvas.style.marginTop = "0px";
                canvas.style.marginLeft = (windowWidth - (this.renderer.width * sy)) * .5 + "px"
            }

            container.style.position = "fixed";
            container.style.width = windowWidth + "px";
            container.style.height = windowHeight + "px";
            container.style.maxWidth = windowWidth + "px";
            container.style.left = "0px";
            container.style.top = "0px";
            container.style.background = "#000";
            container.style.zIndex = "250";
            container.style.transformOrigin = "0px 0px";
            container.style.webkitTransformOrigin = "0px 0px";
            container.style.transform = "scale(1,1)";
            container.style.webkitTransform = "scale(1,1)";
            document.body.style.overflowY = "hidden";
            document.body.style.overflowX = "hidden";

            if (this.touchSupressionHandler === undefined){
                this.touchSupressionHandler = (event)=>{this.handleTouchEventsWhileInFullscreen(event)};
            }

            container.addEventListener("touchstart", this.touchSupressionHandler);
            container.addEventListener("touchmove", this.touchSupressionHandler);
            canvas.style.transform = scale;
            canvas.style.webkitTransform = scale;
            canvas.style.transformOrigin = "left top";
            canvas.style.webkitTransformOrigin = "0px 0px";
            canvas.style.position = "absolute";
            canvas.style.top = "0px";
            canvas.style.left = "0px";
            window.scrollTo(0,0);
            Config.IS_SQUARE = false;
            this.isFullScreen = true;
        }

        public renderDesktopView():void {
            var canvas:HTMLCanvasElement = this.renderer.view;
            var container:HTMLElement = this.renderer.view.parentElement;
            Config.IS_SQUARE = false;

            //frame
            var frameURL = this.assetManifest.desktopMenuUrls.frame;
            var replayButtonURL = this.assetManifest.desktopMenuUrls.replayButton;
            var audioOnURL = this.assetManifest.desktopMenuUrls.audioOnButton;
            var audioOffURL = this.assetManifest.desktopMenuUrls.audioOffButton;
            var closeButtonURL = this.assetManifest.desktopMenuUrls.closeButton;
            var sendButtonURL = this.assetManifest.desktopMenuUrls.sendButton;

            container.style.position = "absolute";
            container.style.width = Config.DESKTOP_FRAME_WIDTH+"px";
            container.style.height = Config.DESKTOP_FRAME_HEIGHT+"px";
            container.style.maxWidth = Config.DESKTOP_FRAME_WIDTH+"px";
            container.style.left = this.desktopFramePosLeft + "px";
            container.style.top = this.desktopFramePosTop + "px";
            container.style.background = "url('"+frameURL+"') no-repeat";
            container.style.zIndex = this.desktopZIndex.toString();

            if (this.desktopButtons.length === 0){
                //buttons
                var closeButton = document.createElement("div");
                closeButton.style.background = "url('"+closeButtonURL+"') no-repeat";
                closeButton.style.width = "145px";
                closeButton.style.height = "50px";
                closeButton.style.position = "absolute";
                closeButton.style.top = "0px";
                closeButton.style.left = "815px";
                closeButton.style.cursor = "pointer";
                closeButton.addEventListener("click", this.handleCloseButton.bind(this));
                container.appendChild(closeButton);
                this.desktopButtons.push(closeButton);

                var replayButton = document.createElement("div");
                replayButton.style.background = "url('"+replayButtonURL+"') no-repeat";
                replayButton.style.width = "101px";
                replayButton.style.height = "40px";
                replayButton.style.position = "absolute";
                replayButton.style.top = "683px";
                replayButton.style.left = "225px";
                replayButton.style.cursor = "pointer";
                replayButton.addEventListener("click", this.resetShow.bind(this));
                container.appendChild(replayButton);
                this.desktopButtons.push(replayButton);

                var audioButton = document.createElement("div");
                audioButton.style.background = "url('"+audioOnURL+"') no-repeat";
                audioButton.style.width = "115px";
                audioButton.style.height = "40px";
                audioButton.style.position = "absolute";
                audioButton.style.top = "683px";
                audioButton.style.left = "100px";
                audioButton.style.cursor = "pointer";
                audioButton.addEventListener("click", this.handleMusicButtonDesktop.bind(this, audioButton, audioOnURL, audioOffURL));
                container.appendChild(audioButton);
                this.desktopButtons.push(audioButton);

                if (this.mode === Mode.Sender){
                    var sendButton = document.createElement("div");
                    sendButton.style.background = "url('"+sendButtonURL+"') no-repeat";
                    sendButton.style.width = "225px";
                    sendButton.style.height = "40px";
                    sendButton.style.position = "absolute";
                    sendButton.style.top = "683px";
                    sendButton.style.left = "640px";
                    sendButton.style.cursor = "pointer";
                    sendButton.addEventListener("click", this.handleSendButton.bind(this));
                    container.appendChild(sendButton);
                    this.desktopButtons.push(sendButton);
                }
            }
            else {
                for (var i=0; i<this.desktopButtons.length; i++){
                    this.desktopButtons[i].style.display = "block";
                }
            }

            //canvas
            var scale = Config.DESKTOP_CANVAS_WIDTH/Config.BASE_WIDTH;
            canvas.style.margin = "0";
            canvas.style.transform = "scale("+scale+","+scale+")";
            canvas.style.webkitTransform = "scale("+scale+","+scale+")";
            canvas.style.transformOrigin = "left top";
            canvas.style.webkitTransformOrigin = "0px 0px";
            canvas.style.position = "absolute";
            canvas.style.top = "137px";
            canvas.style.left = "80px";

            document.body.style.overflowY = "visible";
            document.body.style.overflowX = "visible";
            this.resizeDesktopView()
        }

        public resizeDesktopView():void{
            var container:HTMLElement = this.renderer.view.parentElement;
            container.style.transformOrigin = "left top";
            container.style.webkitTransformOrigin = "0px 0px";
            container.style.left = "0px";
            container.style.top = "0px";
            var contentBoundingRect = this.desktopMeasureContainer.getBoundingClientRect();
            var containerBoundingRect = container.getBoundingClientRect();
            if (this.desktopMeasureContainer.offsetWidth < Config.DESKTOP_FRAME_WIDTH){
                var scale = this.desktopMeasureContainer.offsetWidth / Config.DESKTOP_FRAME_WIDTH;
                container.style.transform = "scale("+scale+","+scale+")";
                container.style.webkitTransform = "scale("+scale+","+scale+")";
            }
            else {
                container.style.transform = "scale(1,1)";
                container.style.webkitTransform = "scale(1,1)";
            }

            container.style.left = (contentBoundingRect.left - containerBoundingRect.left + this.desktopFramePaddingLeft) + "px"
            container.style.top = (contentBoundingRect.top - containerBoundingRect.top + this.desktopFramePaddingTop) + "px";
        }

        public handleTouchEventsWhileInFullscreen(event):void {
            event.preventDefault();
        }

        protected handleMusicButtonDesktop(audioButton:HTMLDivElement, buttonOnURL:string, buttonOffURL:string,event:Event):void {
            if (this.audioController.audioOn){
                this.audioController.pause();
                audioButton.style.background = "url('"+buttonOffURL+"') no-repeat";
            }
            else {
                this.audioController.resume();
                audioButton.style.background = "url('"+buttonOnURL+"') no-repeat";
            }
        }

        public handleCloseButton(event):void {
            this.renderInSquare();
            this.shouldAnimate = false;
            this.audioController.stop();
            if (this.mode === Mode.Preview){
                window.close();
            }
            this.endButton.show();
        }

        public handleSendButton(event):void {
            this.cardData.sendCallback(event, this.cardData.personalizations)
        }

        public resize(event:any):void{
            if (this.isFullScreen){
                //This is delayed to give the address bar time to fall
                // :(
                setTimeout(
                ()=>{this.renderFullscreen()},
                500);
            }
            else if (Config.IS_SQUARE) {
                this.renderInSquare();
            }
            else if (this.desktopView){
                this.resizeDesktopView()
            }

            this.playButton.resize(event);
            this.endButton.resize(event);
        }

        public handleShouldAnimate(event:any){
            this.shouldAnimate = event.shouldAnimate;
        }

        public handleSetPersonalizations(event:any){
            this.cardData.setPersonalizationsCallback(event, this.cardData.personalizations);
        }        
    }
}
